import InputField from "@_common/InputRuleFeild";
import { tableStatusColors } from "@_common/colors";
import { convertCurrentDate, convertMonthYear } from "@_common/date-helpers";
import { formatSmallString, formatText } from "@_common/format-text";
import { changeLegalDuedate } from "@services/task.service";
import { getValue } from "@utils/lodash";
import moment from "moment";
import * as React from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledAccordion,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import OrganizationInformationSvgComponent from "../../../../assets/svg-components/task-details/organization-information";
import RedoSvgComponent from "../../../../assets/svg-components/task-details/redo";
import ApprovalFlowSvgComponent from "../../../../assets/svg-components/task-details/approval-flow";
import EntityMappingSvgComponent from "../../../../assets/svg-components/task-details/entity-mapping";
import EntityMappingDetailsSvgComponent from "../../../../assets/svg-components/task-details/entity-mapping-details";
import AdditionalInfoSvgComponent from "../../../../assets/svg-components/task-details/additional-info";
import { handleDownloadOnClick } from "@_common/downloadfile";
import DownloadNoCircleSvgComponent from "../../../../assets/svg-components/download-nocircle";

interface IVendorComplianceTaskOrganizationInformationProps {
  data: object;
  headerObj: object | any;
  getData: () => void;
}

const VendorComplianceTaskOrganizationInformation = (props: any) => {
  const [levels] = React.useState([
    "level_1",
    "level_2",
    "level_3",
    "level_4",
    "level_5",
    "level_6",
    "level_7",
    "level_8",
    "level_9",
    "level_10",
  ]);

  const mainParams = useParams();
  const { data, headerObj } = props;

  const isDateGreaterThanToday = (dateString: string) => {
    let date = new Date(dateString);
    const providedDate = moment(date, "YYYY-MM-DD");
    const todayDate = moment().startOf("day"); // Set time to the start of today
    return providedDate.isSameOrAfter(todayDate, "day"); // Compare up to the day level
  };

  const [isOpen, setIsOpen] = React.useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const [legal_due_date, setLegal_due_date] = React.useState<any>(null);

  const [submitLoading, setSubmitLoading] = React.useState(false);
  const handleSubmit = async () => {
    try {
      setSubmitLoading(true);
      let resp = await changeLegalDuedate(getValue(mainParams, `id`, ""), {
        legal_due_date: legal_due_date,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSubmitLoading(false);
        setLegal_due_date("");
        props.getData();
        handleModal();
      } else {
        setSubmitLoading(false);
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };

  return (
    <div className="map-vendor__check map-vendor__check--task-details">
      {/* <h4 className="map-vendor__task-title">Additional Information</h4> */}
      {/* <h4 className="map-vendor__task-title">Organization Information</h4> */}
      <div className="d-flex align-items-center master-details-header">
        <AdditionalInfoSvgComponent />
        <h4 className="master-details-title">Additional Information</h4>
      </div>

      <UncontrolledAccordion
        open="1"
        defaultOpen="1"
        className="additional-information-accordion-wrap"
      >
        <AccordionItem>
          <AccordionHeader targetId="1">
            <div className="accordian-header-wrap d-flex align-items-center">
              <OrganizationInformationSvgComponent />
              <div className="accordion-header-title">
                Task Information
              </div>
            </div>
          </AccordionHeader>
          <AccordionBody accordionId="1">
            <div className="org-info-body-wrap">

              <div className="org-info d-flex align-items-center">
                <RedoSvgComponent />
                <div className="org-info-label-value-wrap">
                  <div className="org-info-label"> Site</div>

                  <div className="org-info-value">
                    {formatText(getValue(data, `location.location_name`, ""))}
                  </div>
                </div>
              </div>

              <div className="org-info d-flex align-items-center">
                <RedoSvgComponent />
                <div className="org-info-label-value-wrap">
                  <div className="org-info-label">Month & Year</div>

                  <div className="org-info-value">
                    {convertMonthYear(getValue(data, `month`, "") , getValue(data, `year`, ""))}
                  </div>
                </div>
              </div>

              <div className="org-info d-flex align-items-center">
                <RedoSvgComponent />
                <div className="org-info-label-value-wrap">
                  <div className="org-info-label">Release Date</div>

                  <div className="org-info-value">
                    {convertCurrentDate(getValue(data, `release_date`, ""))}
                  </div>
                </div>
              </div>
              

              <div className="org-info d-flex align-items-center">
                <RedoSvgComponent />
                <div className="org-info-label-value-wrap">
                  <div className="org-info-label">Audit Status</div>

                  <div className="org-info-value">
                    {formatText(getValue(data, `audit_status`, ""))}
                  </div>
                </div>
              </div>

            </div>
          </AccordionBody>
        </AccordionItem>
      </UncontrolledAccordion>

      {getValue(data, `documents`, []).length > 0 && (
        <>
          <div className="download-checkpoint">
            <h4 className="master-details-title">Documents</h4>
          </div>
          {getValue(data, `documents`, []).map((document: any) => (
            <>
              <div
                className="attach-files-wrapper__files d-flex justify-content-between mt-2"
                key={document.id}
                // onClick={() =>
                //   handleDownloadOnClick(document.url, document.name)
                // }
              >
                <p
                  key={document.id}
                  style={{
                    fontSize: "12px",
                    marginTop: "0px",
                    textAlign: "center",
                  }}
                >
                  {formatSmallString(document.name)}
                </p>

                {/* <DownloadNoCircleSvgComponent size={18} /> */}
              </div>
            </>
          ))}
        </>
      )}


      <Modal isOpen={isOpen} toggle={handleModal}>
        <ModalHeader>
          <h6 className="px-2">
            Are you certain you wish to modify the legal deadline?
          </h6>
        </ModalHeader>
        <ModalBody>
          <div className="desc_text_container d-flex align-items-center">
            <img src="/images/reference.svg" className="image-fluid" />
            <p className="ms-2">
              Kindly be aware that for all recurring checkpoints, any
              alterations to the legal due date will result in updates to the
              configuration, leading to the creation of new tasks based on the
              updated configuration.
            </p>
          </div>

          <div className="user-details-wrapper__form-group form-group input-grid-item mt-3">
            <label className="checkpoint-active-details__label">
              Legal Due Date <span className="form-label-error">*</span>
            </label>
            <div className="position-relative">
              <label onClick={(e) => e.preventDefault()}>
                <InputField
                  inputType="DATETYPE-DOB"
                  className="form-control release-date-wrapper__vendor-form-control--calendar"
                  placeholderText="Enter Approver Due Date"
                  minDate={new Date()}
                  value={legal_due_date}
                  onChange={(e: any) => setLegal_due_date(e)}
                  label={"Evaluator Due Date"}
                />
                <img
                  src="/images/calander.svg"
                  className="img-fluid form-image form-image--calender"
                />
              </label>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            onClick={handleModal}
            className="ascent-button ascent-button--header-buttons ascent-button--primary"
          >
            Cancel
          </button>
          <button
            className="ascent-button  ascent-button--header-buttons ascent-button--secondary"
            onClick={handleSubmit}
            disabled={submitLoading}
          >
            {submitLoading ? "Please Wait..." : "Update"}
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default VendorComplianceTaskOrganizationInformation;
